// extracted by mini-css-extract-plugin
module.exports = {"block":"VideoPlayer_block__bRvCM","playerContainer":"VideoPlayer_playerContainer__PI6JS","onlineMark":"VideoPlayer_onlineMark___whrB","player":"VideoPlayer_player__8sM15"};